<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <DialogBrand/>
    <v-toolbar elevation="0">
      <v-text-field
          flat
          solo
          clearable
          prepend-icon="search"
          placeholder="Type something"
          v-model="opsitable.search"
          hide-details
          class=""
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="opennew">
        <v-icon dark>add</v-icon>Tambah
      </v-btn>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getBrands(opsitable)">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
        dense
        sort-by="id"
        :sort-desc="sortdes"
        :headers="headers"
        :search="search"
        :items="brands"
        class="elevation-0"
        item-key="id"
        :options.sync="opsitable"
        :server-items-length="totalbrand"
        :loading="loading"
        @update:options="getBrands(opsitable)">
      <template v-slot:item.brandlogo="{ item }">
        <v-img width="36" class="ma-4" :src="item.brandlogo"></v-img>
      </template>
      <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.status)"
              small
              text-color="white">
            {{ statusText(item.status) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.updateat="{ item }">
        {{formatDate(item.updateat)}}
      </template>
      <template v-slot:item.aksi="{ item }">
        <v-btn  small dark text @click.native="opendialogEdit(item)" class="blue ml-2">
          <v-icon small dark class="mr-1">mdi-pencil</v-icon>
          Edit
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import DialogBrand from '@/components/admin/product/DialogBrand'

export default {
  name: 'Brands',
  components: { DialogBrand },
  data: () => ({
    search: '',
    sortdes: [true],
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      status: '',
      sortBy: ['id']
    },
    headers: [
      {
        text: 'Id',
        value: 'id',
        width: '10'
      },
      {
        text: 'Logo',
        value: 'brandlogo',
        width: '10'
      },
      {
        text: 'Brand',
        value: 'brandname'
      },
      {
        text: 'Update',
        value: 'updateat'
      },
      {
        text: 'status',
        value: 'status'
      },
      {
        text: 'Aksi',
        value: 'aksi'
      }
    ]
  }),
  computed: {
    ...mapState('AdminProducts', ['loading', 'dialogbrand', 'brands', 'totalbrand'])
  },
  methods: {
    ...mapActions('AdminProducts', ['getBrandGroups', 'getBrands', 'setdialogbrand', 'setselectedbrand', 'setisnewbrand']),
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    statusText (val) {
      if (parseInt(val) === 1) {
        return 'Enable'
      } else {
        return 'Disable'
      }
    },
    opennew () {
      this.setisnewbrand(true)
      this.setselectedbrand({
        brandlogo: '',
        status: 1,
        productcategoryid: 0,
        brandname: ''
      })
      this.setdialogbrand(true)
    },
    opendialogEdit (item) {
      this.setisnewbrand(false)
      this.setselectedbrand(item)
      this.setdialogbrand(true)
      this.getBrandGroups({
        search: '',
        itemsPerPage: 100,
        page: 1,
        categoryid: item.productcategoryid
      })
    },
    colorStatus (val) {
      if (parseInt(val) === 0) {
        return 'red'
      }
      if (parseInt(val) === 1) {
        return 'green'
      }
    }
  }
}
</script>

<style scoped>

</style>
